import { useI18nContext } from "@hopper-b2b/i18n";
import { ActionLink, Divider, MobilePopoverCard } from "@hopper-b2b/ui";
import CashbackIcon from "../../../assets/client/cash-back-icon.svg?react";
import Close from "../../../assets/client/close.svg?react";
import HeartIcon from "../../../assets/client/heart-with-background.svg?react";
import { useEnhancedEarnAmount } from "../../../hooks/shared";
import styles from "./styles.module.scss";

export const EnhancedEarnPopover = ({
  isOpen,
  onClose,
  totalPrice,
  isExtended,
}: {
  isOpen: boolean;
  onClose: () => void;
  totalPrice: number;
  isExtended: boolean;
}) => {
  const { t, formatNumber, formatCurrency } = useI18nContext();

  const { calculatePointsEarnAmount, cashbackPercent, pointsPerDollar } =
    useEnhancedEarnAmount();

  const pointsEarned = calculatePointsEarnAmount(totalPrice);

  return (
    <MobilePopoverCard
      open={isOpen}
      onClose={onClose}
      className={styles.EnhancedEarnPopover}
      contentClassName="enhanced-earn-popover-content"
      centered
      topLeftButton={
        <ActionLink
          onClick={onClose}
          content={<Close className="close-icon" />}
        />
      }
    >
      <h2 className="points-title">
        {t("enhancedEarn.learnMorePopover.morePointsTitle", {
          pointsPerDollar,
        })}
      </h2>
      <p className="points-subtitle">
        {t("enhancedEarn.learnMorePopover.morePointsSubtitle", {
          pointsPerDollar,
          cashbackPercent,
        })}
      </p>

      <div className="points-dollars-conversion">
        <div className="top-section">
          <div className="left">
            <p className="amount">{formatCurrency(totalPrice)}</p>
            <p className="amount-info">
              {t("enhancedEarn.learnMorePopover.reservationValue")}
            </p>
          </div>
          <CashbackIcon className="cashback-icon" />
          <div className="right">
            <p className="amount">{formatNumber(pointsEarned)}</p>
            <p className="amount-info">
              {t("enhancedEarn.learnMorePopover.pointsValue", {
                pointsPerDollar,
              })}
            </p>
          </div>
        </div>
        {isExtended ? (
          <>
            <Divider className="divider" />
            <p className="description">
              {t("enhancedEarn.learnMorePopover.morePointsDescription")}
            </p>
          </>
        ) : null}
      </div>

      {isExtended ? <HeartIcon className="heart-icon" /> : null}

      <h2 className="asterisks-title">
        {t("enhancedEarn.learnMorePopover.noAsterisksTitle")}
      </h2>
      <p className="asterisks-subtitle">
        {t("enhancedEarn.learnMorePopover.noAsterisksSubtitle")}
      </p>
      <button className="close-popover" onClick={onClose}>
        {t("close.button")}
      </button>
    </MobilePopoverCard>
  );
};
